module.exports = __webpack_public_path__ + "img/emoji-right.7ba4395e.png";